import Vue from 'vue'

import FlagIcon from 'vue-flag-icon'
import App from './App.vue';
import vuetify from './plugins/vuetify';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import i18n from './plugins/i18n'
import router from './router/index'
import store from './store/index'
import VueSimpleAlert from "vue-simple-alert";
import moment from 'moment';
import axios from '@/plugins/axios';
import status from '@/controllers/statusRequest';
import dataConvertion from '@/controllers/convertion';
import manufactureRequest from '@/controllers/manufactureRequest';
import location from '@/controllers/location';
import context from '@/controllers/context';
import user from '@/controllers/user';
import orderUnit from '@/controllers/orderUnit';
import target from '@/controllers/target';
import contact from '@/controllers/contact';

import * as VueGoogleMaps from 'vue2-google-maps'


import JsonExcel from "vue-json-excel";

Vue.component("downloadExcel", JsonExcel);

// import plugin
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
// don't forget to import CSS styles
import 'tiptap-vuetify/dist/main.css'
// Vuetify's CSS styles 
import 'vuetify/dist/vuetify.min.css'

import VCalendar from 'v-calendar';
import VueGoogleCharts from 'vue-google-charts';
import Viewer from 'v-viewer'

axios.instance.interceptors.response.use(function (response) {
  return response
}, function (error) {
  console.log(error.response)
  if (error.response.status === 401) {
    localStorage.removeItem('access_token');
    router.push('/login');
  }
  return error.response;
});

Vue.use(TiptapVuetifyPlugin, {
  vuetify, // same as "vuetify: vuetify"
  iconsGroup: 'md'
})

Vue.use(VCalendar, {
  componentPrefix: 'vc',  // Use <vc-calendar /> instead of <v-calendar />
});

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBnJKzKGqg4qjRpV_zFdrOxIoB4mOlXKJU',
    libraries: 'places',
    region: 'VI',
    language: 'vi',
  },
  // installComponents: true
})

Vue.use(VueSimpleAlert);
Vue.use(FlagIcon);
Vue.use(axios);
Vue.use(VueGoogleCharts);
Vue.use(Viewer);
Vue.use(status);
Vue.use(dataConvertion);
Vue.use(manufactureRequest);
Vue.use(location);
Vue.use(context);
Vue.use(user);
Vue.use(orderUnit);
Vue.use(target);
Vue.use(contact);

Vue.filter('formateDate', function(value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY");
  }
});

Vue.config.productionTip = false

const app = new Vue({
  vuetify,
  el: '#app',
  i18n,
  store,
  router,
  render: h => h(App)
});

export default app
// new Vue({
//   vuetify,
//   render: h => h(App)
// }).$mount('#app')
